import { render, staticRenderFns } from "./Tool.vue?vue&type=template&id=21bb8a1d&scoped=true"
import script from "./Tool.vue?vue&type=script&lang=js"
export * from "./Tool.vue?vue&type=script&lang=js"
import style0 from "./Tool.vue?vue&type=style&index=0&id=21bb8a1d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21bb8a1d",
  null
  
)

export default component.exports